import { render, staticRenderFns } from "./gaja.vue?vue&type=template&id=fcceec22&scoped=true"
import script from "./gaja.vue?vue&type=script&lang=js"
export * from "./gaja.vue?vue&type=script&lang=js"
import style0 from "./gaja.vue?vue&type=style&index=0&id=fcceec22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcceec22",
  null
  
)

export default component.exports